import React from 'react'

export function StartSolidRoundedIcon() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
      <path d="M9.5 0C4.5295 0 0.5 4.02943 0.5 9C0.5 13.9706 4.5295 18 9.5 18C14.4705 18 18.5 13.9706 18.5 9C18.5 4.02943 14.4705 0 9.5 0ZM12.6106 9.47707L8.11062 12.2896C8.01957 12.3464 7.91604 12.375 7.8125 12.375C7.7187 12.375 7.62477 12.3517 7.53976 12.3044C7.36095 12.2053 7.25 12.0171 7.25 11.8125V6.1875C7.25 5.98289 7.36095 5.79473 7.53976 5.69559C7.71856 5.59589 7.9372 5.60194 8.11062 5.71043L12.6106 8.52293C12.775 8.62594 12.875 8.80611 12.875 9C12.875 9.19389 12.775 9.3741 12.6106 9.47707Z" fill="#38EF7D"/>
    </svg>
  )
}